import { getEnvVar } from 'utils/env';


/**
 * Grab the current node environment.
 *
 * @type {string}
 */
export const NODE_ENV = ESIG.nodeEnv;

/**
 * Determine if we are using the 'development' environment.
 *
 * @type {boolean}
 */
export const isDevEnv = NODE_ENV === 'development';

/**
 * Determine if we are using the 'production' environment.
 *
 * @type {boolean}
 */
export const isProdEnv = NODE_ENV === 'production';

/**
 * Grab the `clientId` for hellosign.
 *
 * @type {string}
 */
export const HELLO_SIGN_CLIENT_ID = getEnvVar('MNL_HELLO_SIGN_CLIENT_ID', ESIG.HelloSign.clientId);
